// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WMUw","col":"styles_col__37sQ4"};